import React from 'react';
import styled from 'styled-components';

import { mq } from '~/lib/mq';

import { ICommerceVariant } from '~/types/ICommerceVariant';

import * as TwoColumn from '~/App/shared/components/Donation/components/Forms/components/TwoColumn/';
import { CertificateSummary } from './CertificateSummary';
import { ICommerceProduct } from '~/types/ICommerceProduct';

const Wrapper = styled(TwoColumn.RightColumn)`
  ${mq('<medium')`
    display: none;
    width: 100%;
    margin-left: 0;
    margin-bottom: 1rem;
  `};
`;

const Card = styled(TwoColumn.ColumnCard)`
  ${mq('<medium')`
     padding: 1rem;
     position: relative;
     max-height: 13rem;
     overflow: hidden;
  `};
`;

const Image = styled.img`
  width: 100%;
`;

type Props = {
  variant: ICommerceVariant;
  product: ICommerceProduct;
  openModal: () => void;
};

export function RightColumn({ variant, product, openModal }: Props) {
  if (product?.type === 'DigitalCertificate') {
    return (
      <Wrapper>
        <Card>
          {/* NOTE: add alt text when supported */}
          {variant.discontinued ? (
            <Image src={variant.primaryImage} aria-hidden />
          ) : (
            <CertificateSummary variant={variant} openModal={openModal} />
          )}
        </Card>
      </Wrapper>
    );
  }

  if (product?.type === 'Physical' && variant.primaryImage) {
    return (
      <Wrapper>
        <Card>
          {/* NOTE: add alt text when supported */}
          <Image src={variant.primaryImage} aria-hidden />
        </Card>
      </Wrapper>
    );
  }

  return <Wrapper />;
}
